class NostoAPILayer {
  constructor () {
    this.eventBus = window.theme.nosto.eventBus
    this.events = window.theme.results.events

    this.setupEventListeners()

    this.trackingEvents()
  }

  trackingEvents () {
    this.eventBus.subscribe(
      this.events.TRACKING.PRODUCT_CLICKED,
      (productData) => {
        const isTrackingAllowed =
          window.Shopify.customerPrivacy?.analyticsProcessingAllowed()

        if (!isTrackingAllowed) return

        window.nostojs((api) => {
          api.recordSearchClick(productData.type, {
            productId: productData.productId,
            url: `${window.theme.shop.url}${productData.productUrl}`,
          })
        })
      },
    )

    this.eventBus.subscribe(
      this.events.TRACKING.PRODUCT_ADDED_TO_CART,
      (productData) => {
        const isTrackingAllowed =
          window.Shopify.customerPrivacy?.analyticsProcessingAllowed()

        if (!isTrackingAllowed) return

        window.nostojs((api) => {
          api.recordSearchAddToCart(productData.type, {
            productId: productData.productId,
            url: `${window.theme.shop.url}${productData.productUrl}`,
          })
        })
      },
    )
  }

  setupEventListeners () {
    this.eventBus.subscribe(
      window.theme.results.events.API.FETCH_PRODUCTS,
      () => {
        this.fetchProducts()
      },
    )
  }

  calculatePaginationOffset (
    currentPage,
    productsPerPage,
    productsPerFirstPage,
  ) {
    if (currentPage <= 1) {
      return 0
    }

    return productsPerFirstPage + (currentPage - 2) * productsPerPage
  }

  async fetchProducts () {
    try {
      window.nostojs((api) => {
        const state = window.theme.results.stateLayer.state

        const activeFacets = state.activeFacets.map((facet) => {
          if (facet.field === 'price' && facet.value?.length) {
            const [min, max] = facet.value[0].split('~')
            return { field: facet.field, range: { gte: min, lte: max } }
          }
          return facet
        })

        const currentPage = state.pagination.currentPage || 1
        const productsPerPage = state.productsPerPage
        const productsPerFirstPage = state.productsPerFirstPage

        const currentProductsPerPage =
          currentPage === 1 ? productsPerFirstPage : productsPerPage

        const apiFrom = this.calculatePaginationOffset(
          currentPage,
          productsPerPage,
          productsPerFirstPage,
        )

        const payload =
          this.pageType === 'search'
            ? this.searchPayload(
              state.activeTerm,
              activeFacets,
              apiFrom,
              currentProductsPerPage,
              state,
            )
            : this.categoryPayload(
              this.categoryId,
              activeFacets,
              apiFrom,
              currentProductsPerPage,
              state,
            )

        let track = 'category'

        if (this.pageType === 'search' && state.activeTerm.length) {
          track = state.activeTerm.trim().length ? 'serp' : undefined
        }

        api
          .search(payload, {
            track,
            redirect: true,
          })
          .then((response) => {
            const API = window.theme.results.events.API
            this.eventBus.publish(API.PRODUCTS_FETCHED, response)

            const facets = response.products.facets || []
            this.eventBus.publish(API.FACETS_FETCHED, facets)
          })
          .catch((error) => {
            console.error('Failed to fetch products from Nosto:', error)
            this.eventBus.publish(this.events.API.SHOPIFY_FALLBACK, {})
          })
      })
    } catch (error) {
      console.error('NostoJS API call failed:', error)
      this.eventBus.publish(this.events.API.SHOPIFY_FALLBACK, {})
    }
  }

  categoryPayload (categoryId, activeFacets, apiFrom, productsPerPage, state) {
    return {
      products: {
        categoryId,
        facets: ['*'],
        fields: [
          'alternateImageUrls',
          'customFields.key',
          'customFields.value',
          'imageUrl',
          'listPrice',
          'name',
          'price',
          'productId',
          'url',
        ],
        filter: activeFacets,
        from: apiFrom,
        sort: state.activeSort || [],
        size: productsPerPage,
      },
    }
  }

  searchPayload (query, activeFacets, apiFrom, productsPerPage, state) {
    return {
      query,
      products: {
        facets: ['*'],
        fields: [
          'name',
          'productId',
          'variantId',
          'imageUrl',
          'tags1',
          'alternateImageUrls',
          'price',
          'listPrice',
          'productType',
          'url',
          'skus.name',
          'skus.id',
          'skus.inventoryLevel',
          'description',
          'customFields.key',
          'customFields.value',
        ],
        filter: activeFacets,
        from: apiFrom,
        sort: state.activeSort || [],
        size: productsPerPage,
      },
    }
  }

  get categoryId () {
    return document.body.dataset.categoryId
  }

  get pageType () {
    return document.body.dataset.pageType
  }
}

window.theme.results.apiLayer = new NostoAPILayer()
